import React from 'react';
import intl from 'react-intl-universal';
import {isNotEmptyString} from "../helpers/JsHelper";

/**
 * Copyright (c) Fing Ltd. All rights reserved.
 *
 * @author Tommaso Latini <tommaso@fing.com>
 */

export default class SearchBar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchedValue: props.value || "",
            hasError: false,
            errorMsg: ""
        }

        // Timeout
        this.timeoutId = null;
        this.timeoutInterval = 500;

        // References
        this.inputRef = React.createRef();

        // Handler
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleTextUpdate = this.handleTextUpdate.bind(this);
    }

    // --------------------------------------------------------------------------------
    // LIFECYCLE
    // --------------------------------------------------------------------------------

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            // console.log(`Update props: '${prevProps.value}'!='${this.props.value}'`);
            this.setState({searchedValue: prevProps.value});
            this.setQueryTimer();
            this.inputRef.current.focus();
        }
    }

    componentDidMount() {
        this.inputRef.current.focus();
    }

    // --------------------------------------------------------------------------------
    // HANDLER
    // --------------------------------------------------------------------------------

    handleKeyDown(e) {
        if (e.key === 'Enter')
            e.preventDefault();
        // console.log("Pressed key: " + e.key);
    }

    handleTextUpdate(value) {
        const {onSearch} = this.props;

        // Caller did not provide a callback function. So, nothing to do when we get an update
        if (!onSearch)
            return;

        if (!isNotEmptyString(value, true)) {
            onSearch(null);
            return;
        }

        const filter = value.trim();
        this.setState({ searchedValue: filter });
        return onSearch(filter);
    }

    // --------------------------------------------------------------------------------
    // TIMEOUT
    // --------------------------------------------------------------------------------

    clearQueryTimer() {
        if (!this.timeoutId)
            return;
        // console.log("Clear timeout: ", this.timeoutId);
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
    }

    // The timer is required for not overwhelming search API
    // The operation is different based on the existence of the captcha.
    setQueryTimer() {
        this.clearQueryTimer();
        this.timeoutId = setTimeout(() => {
            this.handleTextUpdate(this.inputRef.current.value);
        }, this.timeoutInterval)

        // console.log("Set timeout: ", this.timeoutId);
    }

    // --------------------------------------------------------------------------------
    // MAIN RENDER FUNCTION
    // --------------------------------------------------------------------------------

    render() {
        const {id, value} = this.props;
        const {hasError, errorMsg} = this.state;

        const searchText = intl.get('business_devrecog_fingpedia_search');
        return (
            <form className={`js-focus-state input-group ${hasError ? " has-error" : ""}`}
                  onKeyDown={this.handleKeyDown}>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text bg-primary" id={id}>
                            <span className="fas fa-search text-white"/>
                        </span>
                    </div>

                    <input className="form-control"
                           type="search"
                           ref={this.inputRef}
                           placeholder={searchText}
                           value={value}
                           onChange={(e) => {
                                this.setState({hasError: false, errorMsg: ""});
                                this.setQueryTimer();
                            }}
                           aria-label={searchText} aria-describedby={id}/>
                    {hasError === true && (
                        <div className="invalid-feedback d-block">
                            Error: {errorMsg}
                        </div>
                    )}
                </div>
            </form>
        );
    }

}